import { Box, Tabs, Tab, Paper } from '@mui/material'
import { SimpleShowLayout } from 'react-admin'
import { useState } from 'react'

/**
 * CustomTabbedShowLayout - A reusable show layout component with general fields and tabbed fields
 * 
 * @param {Array} generalFields - Array of React elements to render in the general section (above tabs)
 * @param {Array} tabs - Array of tab objects with structure: { label: string, fields: Array<ReactElement> }
 */
export const CustomTabbedShowLayout = ({ generalFields = [], tabs = [] }) => {
  const [tabValue, setTabValue] = useState(0)

  return (
    <>
      {generalFields.length > 0 && (
        <Box sx={{ mb: 3 }}>
          <SimpleShowLayout>
            {generalFields}
          </SimpleShowLayout>
        </Box>
      )}
      {tabs.length > 0 && (
        <Paper sx={{ mt: 2 }}>
          <Tabs
            value={tabValue}
            onChange={(e, newValue) => setTabValue(newValue)}
            aria-label="show tabs"
          >
            {tabs.map((tab, index) => (
              <Tab key={index} label={tab.label} />
            ))}
          </Tabs>
          {tabs.map((tab, index) => (
            <Box
              key={index}
              role="tabpanel"
              hidden={tabValue !== index}
              sx={{ p: 0 }}
            >
              {tabValue === index && (
                <SimpleShowLayout>
                  {tab.fields}
                </SimpleShowLayout>
              )}
            </Box>
          ))}
        </Paper>
      )}
    </>
  )
}

